import { useState, useCallback } from 'react';
import { MCPServer } from '@/shared/types';

export const useServerForm = () => {
  const [formData, setFormData] = useState<Partial<MCPServer>>({
    name: '',
    description: '',
    url: '',
    enabled: true,
    authType: 'none',
    authConfig: {},
  });
  const [isAddingServer, setIsAddingServer] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleAddServer = useCallback(() => {
    setFormData({
      name: '',
      description: '',
      url: '',
      enabled: true,
      authType: 'none',
      authConfig: {},
    });
    setIsAddingServer(true);
    setIsEditing(false);
  }, []);

  const handleEditServer = useCallback((server: MCPServer) => {
    setFormData(server);
    setIsEditing(true);
    setIsAddingServer(false);
  }, []);

  const handleFormDataChange = useCallback((updates: Partial<MCPServer>) => {
    setFormData(prev => ({ ...prev, ...updates }));
  }, []);

  const handleCancel = useCallback(() => {
    setIsAddingServer(false);
    setIsEditing(false);
    setFormData({
      name: '',
      description: '',
      url: '',
      enabled: true,
      authType: 'none',
      authConfig: {},
    });
  }, []);

  const resetForm = useCallback(() => {
    setFormData({
      name: '',
      description: '',
      url: '',
      enabled: true,
      authType: 'none',
      authConfig: {},
    });
    setIsAddingServer(false);
    setIsEditing(false);
  }, []);

  return {
    formData,
    isAddingServer,
    isEditing,
    setFormData,
    setIsAddingServer,
    setIsEditing,
    handleAddServer,
    handleEditServer,
    handleFormDataChange,
    handleCancel,
    resetForm,
  };
};
